import {
  Alert,
  Button,
  ButtonGroup,
  Input,
  Link,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalOverlay,
} from '@apollo/orbit';
import React, { useState } from 'react';

import { DocsRouter } from 'src/lib/routers';
import { safeCompileMarkdown } from 'src/lib/safeCompileMarkdown';

export const ScriptPromptModal = ({
  onSubmit,
  message,
  defaultValue,
}: {
  onSubmit: (response: null | string) => void;
  message: string;
  defaultValue: string | undefined;
}) => {
  const [value, setValue] = useState(defaultValue ?? '');

  return (
    <Modal isOpen={true} onClose={() => onSubmit(null)} size="md">
      <ModalOverlay />
      <ModalContent>
        <ModalBody>
          <div className="[&_ul,ol]:pl-[2em] text-base [&_ol]:list-decimal [&_ul]:list-disc">
            {safeCompileMarkdown(message, {
              overrides: {
                a: {
                  props: {
                    className: 'underline',
                    rel: 'noreferrer noopener',
                    target: '_blank',
                  },
                },
              },
            })}
          </div>
          <Input
            value={value || defaultValue}
            onChange={(event) => setValue(event.target.value)}
          />
          <Alert status="warning">
            This value will be made available to the script for this graph. See
            how this value will be used from Explorer's Settings tab, or{' '}
            <Link
              isExternal
              className="whitespace-nowrap"
              to={DocsRouter.path('ExplorerConnectingWithHash', {
                hash: 'preflight-scripts',
              })}
            >
              Learn more
            </Link>
            .
          </Alert>
        </ModalBody>
        <ModalFooter>
          <ButtonGroup>
            <Button
              variant="secondary"
              onClick={() => onSubmit(null)}
              type="button"
            >
              Close
            </Button>
            <Button
              variant="primary"
              onClick={() => {
                onSubmit(value);
              }}
              type="button"
            >
              Submit
            </Button>
          </ButtonGroup>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
